if (typeof L2H === 'undefined' || L2H === null) { window.L2H = {}; }

let trackerCount = 0;
L2H.Tracker = class Tracker {
  constructor(gaID, permalink, rootURL) {
    this.gaID = gaID;
    this.permalink = permalink;
    this.rootURL = rootURL;
    this.trackerName = `like2have${trackerCount++}`;
    const t = this.ga();
    if (t != null) { t('create', this.gaID , {'name': this.trackerName, cookieDomain: 'auto'}); }
  }

  trackShopableClick(url, photoID) {
    if (L2H.debug) { console.log(`L2H DEBUG: trackShopableClick  ${this.gaID} - ${url}, ${photoID}`); }
    const deferred = new $.Deferred();

    const t = this.ga();
    if (t != null) {
      if (t.hasOwnProperty('loaded') && (t.loaded === true)) {
        setTimeout(function() {
          if (L2H.debug) { console.log("L2H DEBUG: resolving trackShoppableClick in timeout"); }
          return deferred.resolve();
        }
                   , 1000);
        t(`${this.trackerName}.send`, 'event', 'l2h-outbound', `click|${this.permalink}`, url, {
          'hitCallback'() {
            if (L2H.debug) { console.log("L2H DEBUG: resolving trackShoppableClick after GA callback"); }
            return deferred.resolve();
          }
        }
         );
      } else {
        if (L2H.debug) { console.log("L2H DEBUG: resolving trackShoppableClick due to ga not loaded"); }
        deferred.resolve();
      }
    } else {
      if (L2H.debug) { console.log("L2H DEBUG: resolving trackShoppableClick without GA"); }
      deferred.resolve();
    }

    return deferred.promise();
  }

  trackModalView(imageID) {
    if (L2H.debug) { console.log(`L2H DEBUG: trackModalView ${this.gaID} - view|${this.permalink} -> ${this.rootURL}admin/photos/${imageID}`); }
    const t = this.ga();
    if (t != null) { return t(`${this.trackerName}.send`, 'event', 'l2h-modal', `view|${this.permalink}` , `${this.rootURL}admin/photos/${imageID}`); }
  }

  trackPageView() {
    if (L2H.debug) { console.log(`L2H DEBUG: trackPageView ${this.gaID} - view|${this.permalink}`); }
    const t = this.ga();
    const self = this;
    return $(document).ready(function() {
      if (t != null) { return t(`${self.trackerName}.send`, 'pageview'); }
    });
  }

  ga() {
    if (L2H.env !== "production") { return; }
    if (L2H.features.disableGoogleAnalytics) { return; }

    if (L2H.loadGoogleAnalytics && (typeof GoogleAnalyticsObject === 'undefined' || GoogleAnalyticsObject === null)) { L2H.loadGoogleAnalytics(); }
    if (L2H.debug) { console.log(`L2H DEBUG: GoogleAnalyticsObject is ${GoogleAnalyticsObject}`); }

    if (L2H.googleAnalyticsLoaded) {
      return l2hga;
    } else {
      if (typeof GoogleAnalyticsObject !== 'undefined' && GoogleAnalyticsObject !== null) { return window[GoogleAnalyticsObject]; }
    }
  }
};
